import { render, staticRenderFns } from "./Migration.vue?vue&type=template&id=447deb24&"
import script from "./Migration.vue?vue&type=script&lang=js&"
export * from "./Migration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447deb24')) {
      api.createRecord('447deb24', component.options)
    } else {
      api.reload('447deb24', component.options)
    }
    module.hot.accept("./Migration.vue?vue&type=template&id=447deb24&", function () {
      api.rerender('447deb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/Migration.vue"
export default component.exports